module.exports = __webpack_public_path__ + "static/assets/29ca9934f2bb0d40b61a2b77385e271f.svg";